(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accessibility-button"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__footerA11yBound) return;
    window.__footerA11yBound = true;
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.footer-a11y__btn');
      if (!trigger) return;
      var sel = trigger.getAttribute('data-a11y-target');
      if (!sel) return;
      var appBtn = document.querySelector(sel);
      if (appBtn) { appBtn.click(); }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
